module.exports = __webpack_public_path__ + "img/resource-tech-image-39.7d929a3d.jpg";